module.exports = __webpack_public_path__ + "img/120.01066115.jpg";